export const DEFAULT_TOTAL_USER_CREDITS = 12;
